import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const RestoreTaskIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
      fill="none"
    >
      <g>
        <path
          d="M18.526 1.86093V3.84768C18.526 4.11258 18.2611 4.37748 17.9962 4.37748H16.0095"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M3.4267 20.0066V18.0199C3.4267 17.755 3.6916 17.4901 3.9565 17.4901H5.94325"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M2.36708 16.1656C0.115421 12.3245 0.645223 7.29139 3.95648 3.98013C7.92999 0.00662243 14.2876 0.00662243 18.2611 3.98013"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M19.8505 5.96689C22.1022 9.80795 21.4399 14.8411 18.2611 18.0199C14.2876 21.9934 7.92999 21.9934 3.95648 18.0199"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8.59227 6.76159H7.66512C7.26777 6.76159 7.00287 7.15894 7.00287 7.55629V15.2384C7.00287 15.6358 7.26777 16.0331 7.66512 16.0331H14.5525C14.9499 16.0331 15.2148 15.6358 15.2148 15.2384V7.55629C15.2148 7.15894 14.9499 6.76159 14.5525 6.76159H13.4929"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M13.4929 6.76159C13.4929 6.36424 13.0956 5.96689 12.6982 5.96689H9.65188C9.25453 5.96689 8.85718 6.36424 8.85718 6.76159V7.68874H13.6254V6.76159H13.4929Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  </CircledIcon>
);
